import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { Link } from 'react-router-dom';

import { DataTableView, Column } from 'src/core/ui/data-table.view';
import { OptionsDialogView } from 'src/core/ui/options-dialog.view';
import { TextView } from 'src/core/ui/text.view';
import { FormatService } from 'src/core/services/format.service';

@observer
export class SupplierListView extends React.Component<SupplierListViewProps, any> {
	@resolve
	private formatService: FormatService;

	@observable
	showDialog = false;

	constructor(props: any) {
		super(props);
	}

	@autobind
	private createNew() {
		this.showDialog = true;
		return Promise.resolve(null);
	}

	@autobind
	private closeDialog(selectedValue?: string) {
		if (selectedValue) {
			this.props.onItemDoubleClicked(selectedValue as any);
		}
		this.showDialog = false;
	}

	render() {
		const model = this.props.model;
		const items = model.items.map(o => o);
		const columns: Column[] = [
			{
				key: 'title',
				title: 'Title',
				dataIndex: 'title',
				render: (text, record: SupplierSummary) => <Link to={`/products/suppliers/${record.id}`}>{text}</Link>,
			},
			{
				key: 'supplierNumber',
				title: 'Number',
				dataIndex: 'supplierNumber',
				filter: {
					field: 'supplierNumber',
					type: 'string',
					render: (value, onChange) => (
						<TextView
							mode='edit'
							label={null}
							value={value}
							onChanged={onChange}
						/>
					)
				}
			},
			{
				key: 'type',
				title: 'Type',
				dataIndex: 'typeText'
			},
			{
				key: 'defaultMargin',
				title: 'Default Margin',
				dataIndex: 'defaultMargin',
				render: (text: any, record: MarketSummary, index: number) => this.formatService.toString('percent-full', record.defaultMargin)
			}
		];

		return (
			<div className="window window-normal">
				<OptionsDialogView
					closeDialog={this.closeDialog}
					options={[
						{
							key: 'General',
							text: 'General',
							checked: true
						},
						{
							key: 'CarRent',
							text: 'Car rent agency'
						}
					]}
					showDialog={this.showDialog}
					title="Choose a type"
					subtitle="You can choose between a general type or a car rent agency type."
				/>
				<div className="panel">
					<DataTableView
						setBusy={this.props.setBusy}
						columns={columns}
						model={model}
						createNewItem={this.createNew}
						itemDoubleClick={(item) => { if (this.props.onItemDoubleClicked) { this.props.onItemDoubleClicked(item); } }}
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/suppliers/list/supplier-list.view.tsx